// Helper function to normalize image imports (handles both string URLs and module objects)
const getImageUrl = (img: any): string => {
  if (typeof img === 'string') return img;
  if (img && typeof img === 'object' && img.default) return img.default;
  if (img && typeof img === 'object' && typeof img.toString === 'function') return img.toString();
  return String(img);
};

const socotec = getImageUrl(require("../assets/images/socotec.png"));
const location = getImageUrl(require("../assets/images/location.svg"));
const arrowRight = getImageUrl(require("../assets/images/arrow-right.svg"));
const arrowLeft = getImageUrl(require("../assets/images/arrow-left.svg"));
const arrowRightWhite = getImageUrl(require("../assets/images/arrow-right_white.svg"));
const start = getImageUrl(require("../assets/images/start.svg"));
const localisation = getImageUrl(require("../assets/images/localisation.svg"));
const localisation_pending = getImageUrl(require("../assets/images/localisation_pending.svg"));
const infos = getImageUrl(require("../assets/images/infos.svg"));
const contact = getImageUrl(require("../assets/images/contact.svg"));
const agence = getImageUrl(require("../assets/images/agence.svg"));
const eclipse = getImageUrl(require("../assets/images/eclipse.svg"));
const search = getImageUrl(require("../assets/images/search.svg"));
const close = getImageUrl(require("../assets/images/close.svg"));
const infosBulle = getImageUrl(require("../assets/images/infos-bulle.svg"));
const agenceBulle = getImageUrl(require("../assets/images/agence-bulle.svg"));
const locationBulle = getImageUrl(require("../assets/images/location-bulle.svg"));
const contactBulle = getImageUrl(require("../assets/images/contact-bulle.svg"));
const validated = getImageUrl(require("../assets/images/validated.svg"));
const retour = getImageUrl(require("../assets/images/retour.svg"));
const retourWhite = getImageUrl(require("../assets/images/retour-white.svg"));
const photo = getImageUrl(require("../assets/images/photo.svg"));
const echanger = getImageUrl(require("../assets/images/echanger.svg"));
const refresh = getImageUrl(require("../assets/images/refresh.svg"));
const picture = getImageUrl(require("../assets/images/picture.png"));
const stars = getImageUrl(require("../assets/images/stars.svg"));
const hide = getImageUrl(require("../assets/images/hide.svg"));
const show = getImageUrl(require("../assets/images/show-eye.svg"));
const noun = getImageUrl(require("../assets/images/noun.svg"));
const camera = getImageUrl(require("../assets/images/camera.svg"));
const gallery = getImageUrl(require("../assets/images/gallerie.svg"));
const ok = getImageUrl(require("../assets/images/ok.svg"));
const ko = getImageUrl(require("../assets/images/ko.svg"));
const valider = getImageUrl(require("../assets/images/valider.svg"));
const fermer = getImageUrl(require("../assets/images/fermer.svg"));
const intervenant = getImageUrl(require("../assets/images/intervenant.svg"));
const fiche = getImageUrl(require("../assets/images/fiche.svg"))
const casque = getImageUrl(require("../assets/images/casque.svg"))
const plus = getImageUrl(require("../assets/images/plus.svg"))
const plusWhite = getImageUrl(require("../assets/images/plus-white.svg"))
const transfertRapport = getImageUrl(require("../assets/images/transfert-rapport.svg"))
const done = getImageUrl(require("../assets/images/done.svg"))
const interrogation = getImageUrl(require("../assets/images/interrogation.svg"))
const retry = getImageUrl(require("../assets/images/retry.svg"))
const home = getImageUrl(require("../assets/images/home.svg"))

const images = {
  socotec,
  location,
  arrowRight,
  arrowLeft,
  arrowRightWhite,
  start,
  eclipse,
  localisation,
  localisation_pending,
  infos,
  contact,
  agence,
  search,
  close,
  infosBulle,
  agenceBulle,
  locationBulle,
  contactBulle,
  validated,
  retour,
  retourWhite,
  photo,
  echanger,
  refresh,
  picture,
  stars,
  hide,
  show,
  noun,
  camera,
  gallery,
  ok,
  ko,
  valider,
  fermer,
  intervenant,
  fiche,
  casque,
  plus,
  plusWhite,
  transfertRapport,
  done,
  interrogation,
  retry,
  home,
};

export default images;
